import type { TourStep } from '@/components/tour';

// 멤버별 권한 화면 사용법 안내 — 순서 = 화면 흐름(검색 → 프로필 → Stage별 권한 → 게임별 권한 → 적용).
// scene 'stage': Stage별 권한 아코디언을 펼친 상태가 필요한 단계.
export const MEMBER_PERMS_TOUR_STEPS: TourStep[] = [
  {
    target: 'member-search',
    title: '멤버 찾기',
    body: '권한을 확인하거나 바꿀 사람의 이메일을 입력하세요. 목록에서 고르거나 Enter를 누르면 아래에 그 사람의 권한이 열립니다. 아직 Orbit에 없는 이메일도 그대로 입력해 새로 권한을 줄 수 있습니다.',
  },
  {
    target: 'member-profile',
    title: '권한 요약 태그',
    body: '이 사람이 지금 갖고 있는 권한의 요약입니다. "Stage N개"는 Stage별 권한, "개별 게임 N개"는 게임별 권한 수입니다. 모든 Stage 권한을 갖고 있으면 "모든 게임 권한" 하나로만 표시됩니다.',
  },
  {
    target: 'stage-box',
    scene: 'stage',
    title: 'Stage별 권한이란',
    body: '게임 하나하나가 아니라 "Stage에 속한 게임 전체"에 주는 권한입니다. 새 게임이 그 Stage에 들어오면 자동으로 권한이 생기고, 게임이 다른 Stage로 승격·이동하면 그 게임에 대한 권한은 자동으로 빠집니다.',
  },
  {
    target: 'stage-add',
    scene: 'stage',
    title: 'Stage 넣기',
    body: '왼쪽은 아직 권한이 없는 Stage입니다. 원하는 역할(Viewer 또는 Editor) 버튼을 누르면 그 역할로 오른쪽 보유 권한에 들어가고, 왼쪽에서는 사라집니다.',
  },
  {
    target: 'stage-held',
    scene: 'stage',
    title: '보유 Stage 관리',
    body: '현재 갖고 있는 Stage와 이번에 새로 넣은 Stage가 여기에 모입니다. Viewer/Editor 버튼으로 역할을 바꾸고, 행 끝의 ×를 누르면 권한을 뺍니다. 뺀 Stage는 왼쪽 목록으로 돌아가고, 아래 변경 적용을 누를 때 실제로 회수됩니다.',
  },
  {
    target: 'game-box',
    title: '게임별 권한이란',
    body: '특정 게임 하나에 직접 주는 권한입니다. Stage가 바뀌어도 그대로 유지되므로, 승격 여부와 상관없이 계속 봐야 하는 게임은 여기서 줍니다. Stage별 권한과 함께 가지면 둘 중 높은 역할이 적용됩니다.',
  },
  {
    target: 'game-toolbar',
    title: '게임 찾기와 한 번에 넣기',
    body: 'Stage 필터는 여러 개를 동시에 고를 수 있고 기본은 Stage 1을 뺀 전체입니다. 검색은 이름·prefix·ID로 됩니다.',
  },
  {
    target: 'game-bulk',
    title: '전체 추가',
    body: '지금 검색 결과에 있는 게임을 한 번에 추가하는 행입니다. Viewer 또는 Editor를 누르면 그 역할로 모두 오른쪽에 들어갑니다. 게임 목록 항목이 아니라 점선으로 구분해 두었습니다.',
  },
  {
    target: 'game-add',
    title: '게임 넣기 — Viewer와 Editor의 차이',
    body: '각 게임 행의 Viewer 또는 Editor를 누르면 그 역할로 오른쪽에 들어갑니다. Viewer는 대시보드와 BigQuery의 기본 데이터(mart)를 조회할 수 있고, Editor는 여기에 더해 분석용 raw 데이터를 조회하고 playground에 결과를 쓸 수 있습니다. 보유 권한에서 빼낸 게임은 이 목록 맨 위에 "권한 회수" 표시로 모이며 "회수 취소"로 되돌립니다.',
  },
  {
    target: 'game-held',
    title: '보유 게임 관리',
    body: '현재 갖고 있는 게임과 이번에 새로 넣은 게임이 여기에 모입니다. Stage 필터와 검색으로 좁혀 볼 수 있고, 게임마다 Viewer/Editor를 바꾸거나 ×로 뺍니다.',
  },
  {
    target: 'game-held-bulk',
    title: '일괄 회수',
    body: '"권한 추가 취소"는 아직 저장하지 않은 추가만 되돌려 왼쪽 목록으로 보냅니다. "전체 회수"는 갖고 있던 게임 권한을 모두 회수 대상으로 옮기며, 아래 변경 적용을 눌러야 실제로 회수됩니다.',
  },
  {
    target: 'apply-bar',
    title: '변경 적용',
    body: '여기서 고른 Stage·게임 변경이 모두 모입니다. 버튼 하나로 Stage 변경을 먼저 저장하고 이어서 게임 변경을 적용합니다. 관리자는 즉시 반영되고 BigQuery 권한도 함께 바뀝니다. 일반 멤버는 변경 사유를 적어 승인 요청을 보냅니다.',
  },
];
